import React, { Suspense, useState } from "react";
import "../ChangePassword/ChangePassword.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "../../components/Loading";
import Footer from "../../DefaultLayout/Footer";
import {
 
  CircularProgress,
} from "@mui/material"; 
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { toast } from "react-toastify";
import { Button, Form, } from "reactstrap";
import { changePassword, loadUser } from "../../actions/authActions";
import { connect,  } from "react-redux";
import { checkRequiredValidationWithMinMax } from "../../Helpers/Validation";

function ChangePassword(props) {
  const { frontLabelsName } = props.label;
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const[disableSubmitButton,setDisableSubmitButton]=useState(false)
  const [error_Old, set_Error_Old] = useState("");
  const [error_New, set_Error_New] = useState("");
  const [error_Confirm, set_Error_Confirm] = useState("");

  const handlePassword = () => {
    let validationFlag = true;
    let errNew = "";

    let errOld = "";
    let errorConfirm = "";

    errNew = checkRequiredValidationWithMinMax(
      newPassword,
      "lbl_new_password",
      6,
      15
    );
    errOld = checkRequiredValidationWithMinMax(
      oldPassword,
      "lbl_old_password",
      6,
      15
    );
    errorConfirm = checkRequiredValidationWithMinMax(
      confirmPassword,
      "lbl_confirm_password",
      6,
      15
    );
    if (newPassword !== confirmPassword) {
      errorConfirm = frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_password_not_matching")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_password_not_matching")[0][
              "value"
            ] || "lbl_password_not_matching"
          : "lbl_password_not_matching"
        : "lbl_password_not_matching";
    }

    if (errorConfirm || errOld || errNew) {
      validationFlag = false;
      set_Error_Old(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errOld).length > 0
            ? frontLabelsName.filter((e) => e.key == errOld)[0]["value"] || errOld
            : errOld
          : errOld
      );
      set_Error_New(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errNew).length > 0
            ? frontLabelsName.filter((e) => e.key == errNew)[0]["value"] || errNew
            : errNew
          : errNew
      );
      set_Error_Confirm(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errorConfirm).length > 0
            ? frontLabelsName.filter((e) => e.key == errorConfirm)[0]["value"] ||
              errorConfirm
            : errorConfirm
          : errorConfirm
      );
    } else {
      validationFlag = true;
      set_Error_Old("");
      set_Error_New("");
      set_Error_Confirm("");
    }
    const data = {
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };
    if (validationFlag) {
      setDisableSubmitButton(true)
      props
        .changePassword(data)
        .then((res) => {
          setDisableSubmitButton(false)
          if (res) {
            toast.success(
              frontLabelsName
                ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
                  ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                      "value"
                    ] || res.data.message
                  : res.data.message
                : res.data.message
            );
            props.loadUser();

            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
          }
        })
        .catch((err) => {
          setDisableSubmitButton(false)
          toast.error(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                  .length > 0
                ? frontLabelsName.filter(
                    (e) => e.key == err.response.data.message
                  )[0]["value"] || err.response.data.message
                : err.response.data.message
              : err.response.data.message
          );
        });
    }
  };
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container">
        <div className="change-pwd-main">
          <div className="change-pwd-desc">
            <Form>
              <div className="text-center">
                <h2 className="set-font-size">
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_change_password")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_change_password"
                        )[0]["value"] || "lbl_change_password"
                      : "lbl_change_password"
                    : "lbl_change_password"}
                </h2>
              </div>

              <div className="form">
                <div className="form-item">
                  <input
                    type="password"
                    id="Password"
                    autocomplete="off"
                    required
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                  {error_Old && (
                    <span className="invalid_span">{error_Old}</span>
                  )}
                  <label for="Old Password">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_old_password")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_old_password"
                          )[0]["value"] || "lbl_old_password"
                        : "lbl_old_password"
                      : "lbl_old_password"}
                  </label>
                </div>
                <div className="form-item">
                  <input
                    type="password"
                    id="Password"
                    autocomplete="off"
                    required
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  {error_New && (
                    <span className="invalid_span">{error_New}</span>
                  )}
                  <label for="New Password">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_new_password")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_new_password"
                          )[0]["value"] || "lbl_new_password"
                        : "lbl_new_password"
                      : "lbl_new_password"}
                  </label>
                </div>
                <div className="form-item">
                  <input
                    type="password"
                    id="Password"
                    autocomplete="off"
                    required
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  {error_Confirm && (
                    <span className="invalid_span">{error_Confirm}</span>
                  )}
                  <label for="Confirm New Password">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_confirm_new_password"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_confirm_new_password"
                          )[0]["value"] || "lbl_confirm_new_password"
                        : "lbl_confim_new_password"
                      : "lbl_confirm_new_password"}
                  </label>
                </div>
                <div className="button-set text-center">
                  <Button onClick={handlePassword}>
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_change_my_pwd")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_change_my_pwd"
                          )[0]["value"] || "lbl_change_my_pwd"
                        : "lbl_change_my_pwd"
                      : "lbl_chang_my_pwd"}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}
const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, { changePassword, loadUser })(
  ChangePassword
);
